export default __webpack_public_path__ + "static/media/icon_main_button_arrow_up.5aa17c25.svg";